import { useTableAnalysis } from '@hooks/features/useTableAnalysis';
import { Container, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { SeriesTable } from '@containers/DigitalAnalyst/components/SeriesTable';
import React from 'react';

export const RunGridModeTable = ({ onGoBack, docMode, tool, selectedAgent }) => {
  const { tableRows, selectedDocuments } = useTableAnalysis();

  return (
    <Page width={'100%'}>
      <Container>
        <BackArrowButton onClick={onGoBack} />
        <Container top={24}>
          <SeriesTable
            tableRows={tableRows}
            docColumns={selectedDocuments}
            tool={tool || docMode}
            docMode={docMode}
            selectedAgent={selectedAgent}
          />
        </Container>
      </Container>
    </Page>
  );
};
